/* AMESHI V41 — visible style-with slider and working quick-add buttons. */
(() => {
  const init = root => {
    root.querySelectorAll('[data-style-with]').forEach(section => {
      if (section.dataset.styleReady === '1') return;
      section.dataset.styleReady = '1';
      const rail = section.querySelector('[data-style-rail]');
      if (!rail) return;
      const cards = [...rail.querySelectorAll('.ameshi-style-with__card')];
      const prev = section.querySelector('[data-style-prev]');
      const next = section.querySelector('[data-style-next]');
      const status = section.querySelector('[data-style-message]');
      if (cards.length < 2) {
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
      }
      let index = 0;
      const refresh = () => {
        if (!cards.length) return;
        const railX = rail.getBoundingClientRect().left;
        let closest = 0, distance = Infinity;
        cards.forEach((card, i) => {
          const d = Math.abs(card.getBoundingClientRect().left - railX);
          if (d < distance) {distance = d;closest = i;}
        });
        index = closest;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      const scrollToCard = target => {
        index = Math.max(0, Math.min(cards.length - 1, target));
        const destination = cards[index].offsetLeft - cards[0].offsetLeft;
        rail.scrollTo({left:Math.min(Math.max(0,destination),Math.max(0,rail.scrollWidth-rail.clientWidth)),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      };
      prev?.addEventListener('click', () => scrollToCard(index - 1));
      next?.addEventListener('click', () => scrollToCard(index + 1));
      rail.addEventListener('scroll', () => window.requestAnimationFrame(refresh), {passive:true});
      window.addEventListener('resize', refresh, {passive:true});
      rail.addEventListener('keydown', e => {
        if (e.target.closest('a,button')) return;
        if (e.key==='ArrowRight') {e.preventDefault();scrollToCard(index+1);}
        if (e.key==='ArrowLeft') {e.preventDefault();scrollToCard(index-1);}
      });
      section.querySelectorAll('[data-style-add]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const id = Number(btn.getAttribute('data-style-add'));
          if (!Number.isInteger(id) || !id) return;
          btn.disabled = true;
          btn.setAttribute('aria-busy','true');
          if (status) status.textContent = 'Adding to your bag…';
          try {
            const response = await fetch('/cart/add.js', {
              method:'POST',
              headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({id,quantity:1})
            });
            if (!response.ok) throw new Error('Unable to add this style. Please try again.');
            if (status) status.textContent = 'Added to your bag.';
            const opener = document.querySelector('[data-cart-open]');
            if (opener) opener.click();
          } catch(e) {
            if (status) status.textContent = e.message || 'Unable to add this style.';
          } finally {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
      });
      refresh();
    });
  };
  if (document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
